app.controller('CIFKTP-CTRL', function ($scope, $rootScope, $routeParams, uibDateParser, deviceDetector,
    $uibModal, $http, $window, $location, $timeout, Upload, $q, $filter) {

    $scope.CIFInvestor = {};
    $scope.ktpPhoto = '';
    $scope.device = deviceDetector;
    $scope.append = '';
    $scope.editMode = false;

    $scope.filenameKTP = "";
    $scope.fileKTP = "";
    $scope.fileKTPext = "";
    $scope.KTPFile = [];

    $scope.openCamera = function () {
        let message = 'KTP';
        let url = 'ModalCamera.html';
        let ctrl = 'CameraController';


        // if ($scope.device.isMobile())
        // {
        //url = 'ModalBrowse.html';
        //ctrl = 'BrowseController';
        //$scope.append = 'data:image/png;base64,';
        // }

        var modalInstance = $uibModal.open({
            animation: true,
            templateUrl: url,
            controller: ctrl,
            size: 'md',
            resolve: {
                items: function () {
                    return message;
                }
            }
        });
        modalInstance.result.then(function (resolvedResponse) {
            //console.log('ktp',resolvedResponse);
            if (resolvedResponse) {
                $scope.ktpPhoto = resolvedResponse;
            }
        }, function () { });
    };

    $scope.KTPcapture = function () {
        $scope.$broadcast('ngWebcam_capture');
    };


    $scope.KTPremove = function () {
        $scope.ktpPhoto = '';
    };

    $scope.KTPonCaptureComplete = function (src) {

            $scope.series5 = [];
            for (var i = 0; i < src.length; i++) {
                $scope.series5.push(src[i]);
            }
            $scope.submit();

    };

    var allPromise = $q.all([
        //$http({
        //    method: 'POST',
        //    url: 'service/client.svc/retrieveSession',
        //}).then(function (data) {
        //    if (!data.data.d) {
        //        $http({
        //            method: 'GET',
        //            url: 'service/client.svc/SignOut',
        //        }).then(function (data) {
        //            if (data.data.d == true) {
        //                $window.location.href = "#/login";
        //                $window.location.reload();
        //            }
        //        }, function (error) { })
        //    }
        //    else
        //        $scope.currentUser = data.data.d;
        //}, function (error) { }),


    ]);



    allPromise.then(function () {
        //$http({
        //    method: 'GET',
        //    url: 'service/client.svc/getCIF',
        //}).then(function (data) {
        //    if (data.data.d != null) {
        //        var obj = data.data.d;
        //        $scope.CIFInvestor = data.data.d;
        //        $scope.CIFInvestor.Stage = 1;


        //    } // END IF data.data.d
        //}, function (error) { });
    });

    $scope.submit = function () {
        //console.log(item);
        if (ktpPhoto) {
            let image = ktpPhoto.replace("data:image/jpeg;base64,", "");
            console.log('start OCR');
            $rootScope.AlertShowLoading('warning', 'Loading...', '', 0);
            $http({
                method: 'POST',
                url: 'service/client.svc/OCRKTP',
                data: {
                    "ktpimage": image
                },
            }).then(function (data) {
                swal.close();
                if (data.data.d.result) {
                    $scope.ocrVerijelas = true;
                    $window.location.href = "#/cif/data-pribadi";
                }
                else {
                    console.log(data);
                    swal.fire(data.data.d.message, 'Foto KTP tidak sesuai/kurang jelas', 'error');
                }

            }, function (error) {
                swal.fire('Error', 'error - Please check your connection' + error, 'error');
            });
        }
        else {
            swal.fire('Error', 'Please take id card photo', 'error');
        }
    }

    $scope.logOff = function () {
        $http({
            method: 'POST',
            url: 'service/client.svc/logOff',
        }).then(function (data) {
            console.log(data);
            if (data.data.d == true) {
                $window.location.href = "#/login";
                $window.location.reload();
            }
        }, function (error) { })
    };

    $scope.print = function () {
        $scope.prepareData();
    }

});

